// Should the landing page render WITHOUT the English/Indonesian switch on the server?
//
// Navbar, HeroSection and Footer (layout/landing-v2) hide the switch after mount when the
// cf_country cookie names a country other than Indonesia. The server already has the same
// edge country (cf-ipcountry), so deciding here renders that final state at once. Before
// (19 Oct 2026) every visitor outside Indonesia got the switch from SSR and then saw it
// removed, which slid the desktop menu sideways: PageSpeed desktop CLS 0.21, the failed
// "Agentic Browsing" check.
//
// Same test as the client side: a valid two-letter code (normalizePaymentCountry in
// helpers/setCookie.js) that is not ID. Unknown or odd values (empty, "T1") keep the switch,
// exactly as the client does.
const isOutsideIndonesiaCountry = (country) => {
  if (typeof country !== "string") {
    return false;
  }
  const code = country.trim().toUpperCase();
  return /^[A-Z]{2}$/.test(code) && code !== "ID";
};

module.exports = { isOutsideIndonesiaCountry };
